import { render, staticRenderFns } from "./Cohabiting.vue?vue&type=template&id=6475695a"
import script from "./Cohabiting.vue?vue&type=script&lang=js"
export * from "./Cohabiting.vue?vue&type=script&lang=js"
import style0 from "./Cohabiting.vue?vue&type=style&index=0&id=6475695a&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports